<script setup lang="ts">
/**
 * Use the query params.
 */
const { config } = useParams()
</script>
        
<template>
    <div class="flex h-full flex-col bg-white">
        <div class="flex items-center">
            <div class="min-w-0 flex-1 px-4 lg:w-auto">
                <WorldBreadcrumb />
            </div>
            <div class="min-w-0 flex-shrink-0">
                <slot />
            </div>
        </div>

        <div class="flex flex-1 flex-col overflow-x-hidden">
            <Suspense :timeout="0">
                <WorldDataImportingRisk v-if="config.dimension === 'i'" />

                <WorldData v-else-if="config.dimension" />

                <WorldFramework v-else-if="config.showFramework" />

                <WorldOverview v-else />

                <template #fallback>
                    <UiLoader />
                </template>
            </Suspense>
        </div>
    </div>
</template>